require("@babel/polyfill");

import rwxPreload from 'roseworx/js/modules/rwxPreload';
import rwx from 'roseworx';

require('./index.scss');

import Navigation from './js/navigation.js';
Navigation(rwx.sliders);

var copyClipboard;
window.copyToClipboard = (text) => {
	copyClipboard.value = text;
	let copyText = copyClipboard;
	copyText.select();
	copyText.setSelectionRange(0, 99999);
	document.execCommand("copy");
}

window.addEventListener('load', ()=>{
	copyClipboard = document.createElement('textarea');
	copyClipboard.style.position = "fixed";
	copyClipboard.style.width = "0px";
	copyClipboard.style.height = "0px";
	document.body.appendChild(copyClipboard);

	[...document.querySelectorAll('h4[id], h5[id], h6[id]')].map((h)=>{
		h.addEventListener('click', ()=>{
			copyToClipboard(`${window.location}#${h.id}`);
			h.classList.add('copied');
		  setTimeout(()=>{h.classList.remove("copied")}, 5000);
		});
	});

});

require('./js/codeBlocks.js');